<template>
<div class="subhead-image" :class="[widgetConfig.ImagePlacement === leftImgPlacement ? 'reverse' : '' ]">
    <div class="body-text" :class="[widgetConfig.ImagePlacement === leftImgPlacement ? 'p-fix-right-reverse-content' : 'p-fix-left-content' ]">
        <span v-if="widgetConfig.Header !== headerSize.HIDDEN" :class="[widgetConfig.Header === headerSize.MEDIUM ? 'sub-title-medium' : 'sub-title-small']"> {{widgetConfig.HeaderText}} </span>
        <span v-if="widgetConfig.BodyText"><p  v-html="widgetConfig.BodyText"></p></span>
    </div>
    <div class="img-div" :class="[widgetConfig.ImagePlacement === leftImgPlacement ? 'p-fix-right-reverse-image' : 'p-fix-left-image' ]">
        <img class="img-width" :src="widgetConfig.ImageUrl" alt="">
    </div>
</div>
</template>

<script>
export default {
    name: "SubheadImage",
    data(){
        return{
            leftImgPlacement: "Left",
            headerSize: {
                HIDDEN: 'Hidden',
                MEDIUM: 'Medium'
            }
        }
    },
    props: {
        widgetConfig: Object
    },
}
</script>

<style lang="scss" scoped>
.subhead-image {
    margin: 0 auto;
    display: flex;

    .p-fix-left-content {
        padding: 16px 12px 16px 10px;
    }

    .p-fix-left-image {
        padding: 16px 10px 16px 12px;
    }

    .body-text {
        width: 50%;

        .sub-title-medium {
            font-size: 26px;
            font-weight: 300;
            display: block;
            margin-bottom: 20px;
            line-height: 36px;
            color: black;
        }

        .sub-title-small {
            font-size: 20px;
            font-weight: 500;
            display: block;
            margin-bottom: 20px;
            line-height: 26px;
            color: black;
        }

    }

    .img-div {
        width: 50%;

        .img-width {
            width: 100%;
            height: 272px;
        }
    }

}

.reverse {
    flex-direction: row-reverse;

    .p-fix-right-reverse-content {
        padding: 16px 10px 16px 12px !important;
    }

    .p-fix-right-reverse-image {
        padding: 16px 12px 16px 10px !important;
    }
}

@include wide-mobile {

    .subhead-image {
        display: flex;
        flex-direction: column-reverse;

        .p-fix-left-content {
            padding: 12px 24px 16px 24px !important
        }

        .p-fix-left-image {
            padding: 16px 0px 12px 0px !important;
        }

        .body-text {
            width: 100%;
        }

        .img-div {
            width: 100%;

            .img-width {
                width: 100%;
                height: 232px;
            }
        }

    }

    .reverse {
        .p-fix-right-reverse-image {
            padding: 16px 0px 12px 0px !important;
        }

        .p-fix-right-reverse-content {
            padding: 12px 24px 16px 24px !important
        }

    }
}
</style>
